"use client"

import { use } from "react";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { Control, Controller, FieldErrors, UseFormRegister, useWatch } from "react-hook-form";
import { MultilingualInput, MultilingualTextareaInput } from "../GlobalWidgetEditor";
import TextInput from "../../input/TextInput";
import SelectField from "../../input/SelectField";
import MultipleSelector, { Option } from "@/components/ui/MultipleSelector";
import { searchProducts } from "@/core/lib/api/account/sog/products";

interface ProductListWidgetProps {
    widgetIndex: number;
    name: string;
    control: Control<any>;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    disabled?: boolean;
}

const LIST_OPTIONS = [
    { value: "select", label: "انتخابی" },
    { value: "new", label: "جدیدترین" },
];

export const ProductListWidget = ({
    widgetIndex,
    name,
    control,
    register,
    errors,
    disabled,
}: ProductListWidgetProps) => {
    const { dictionary } = useDictionary();

    const typeList = useWatch({
        control,
        name: `${name}.${widgetIndex}.type_list`
    })

    return (
        <div className="space-y-4">
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.title`}
                label={dictionary.forms?.title}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.subtitle`}
                label={dictionary.forms?.subtitle}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualTextareaInput
                baseName={`${name}.${widgetIndex}.description`}
                label={dictionary.forms?.description}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <TextInput
                name={`${name}.${widgetIndex}.link`}
                label={dictionary.forms?.link}
                placeholder={dictionary.forms?.link}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <div className="space-y-2">
                <Controller
                    control={control}
                    name={`${name}.${widgetIndex}.type_list`}
                    render={({ field, fieldState }) => (
                        <SelectField
                            label="مدل نمایش محصولات"
                            value={field.value || ""}
                            onValueChange={field.onChange}
                            options={LIST_OPTIONS}
                            placeholder="مدل نمایش محصولات"
                            disabled={disabled}
                            error={fieldState.error?.message}
                        />
                    )}
                />
            </div>

            {typeList === "select" &&
                <Controller
                    control={control}
                    name={`${name}.${widgetIndex}.params`}
                    render={({ field }) => (
                        <div className="flex flex-col gap-2">
                            <label className="text-primary-900" htmlFor={field.name}>
                                {dictionary.nav?.products}
                            </label>

                            <MultipleSelector
                                value={(field.value || []).map((v: Option) => ({
                                    ...v,
                                    value: String(v.value)
                                }))}
                                onChange={field.onChange}
                                placeholder={dictionary.nav?.products}
                                fetchFunction={searchProducts}
                                emptyIndicator={
                                    <p className="text-center text-sm leading-10 text-gray-600 dark:text-gray-400">
                                        {dictionary.common?.noResult}
                                    </p>
                                }
                            />
                        </div>
                    )}
                />

            }

        </div>
    );
};
